//
// Module for the employerDirect FAQ edit view
//
rs.module("content/system/configuration/employerdirectbroadcastmessages/edit",

    [
        "common/select-helper",
    ],

    function (selectHelper) {
        // initialize the module
        function initialize(jsSelectors) {
            var form = $.js(jsSelectors.form);
            var startDate = form.js(jsSelectors.startDate);
            var startTime = form.js(jsSelectors.startTime);
            var endDate = form.js(jsSelectors.endDate);
            var endTime = form.js(jsSelectors.endTime);
            var loginFlagSelector = form.js(jsSelectors.loginFlagSelector);
            var fundSelector = form.js(jsSelectors.fundSelector);
            var fundSelectHelper = selectHelper.getHelper(fundSelector);

            startDate.change(function () {
                if (!startDate.val()) {
                    startTime.val(null);
                }
                else if (!startTime.val()) {
                    startTime.val("00:00:00")
                }
            });

            endDate.change(function () {
                if (!endDate.val()) {
                    endTime.val(null);
                }
                else if (!endTime.val()) {
                    endTime.val("23:59:00")
                }
            });
            
            loginFlagSelector.change(function () {
                var preLoginFlag = !(loginFlagSelector.val() == "False");
                fundSelectHelper.setDisabled(preLoginFlag);
                if (preLoginFlag) {
                    fundSelectHelper.setValue(null);
                }
            });            
        }
        
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);